
define('text!modules/base/templates/base.search.reset.template.html',[],function () { return '<input type="search" class="form-control mRight10 searchBar" placeholder="">\r\n<span class="reset_icon"><i class="fa fa-times"></i></span>\r\n';});

